import React from "react";

import "./CftCard.scss";

function CftCard(props) {
  return <div className="cft-card" {...props} />;
}

export default CftCard;
